import { render, staticRenderFns } from "./patient_detail.vue?vue&type=template&id=24fb1539&scoped=true"
import script from "./patient_detail.vue?vue&type=script&lang=js"
export * from "./patient_detail.vue?vue&type=script&lang=js"
import style0 from "./patient_detail.vue?vue&type=style&index=0&id=24fb1539&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fb1539",
  null
  
)

export default component.exports